// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-upgrade-message-notification {
  display: block;
  position: relative;
  color: var(--fi-color-white);
  background-color: var(--branded-background-color);
  padding: 20px 5px;
  font-size: 20px;
}
.fi-upgrade-message-notification .fi-upgrade-message-header {
  display: inline-block;
  padding-left: 24px;
  padding-right: 24px;
}
.fi-upgrade-message-notification .fi-upgrade-message-notification-close {
  position: absolute;
  right: 0px;
  top: 0px;
}
.fi-upgrade-message-notification .fi-upgrade-message-notification-close .fa {
  color: var(--fi-color-white);
}`, "",{"version":3,"sources":["webpack://./Source/app/utilities/notification/upgrade-message-notification/upgrade-message-notification.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,kBAAA;EACA,4BAAA;EACA,iDAAA;EACA,iBAAA;EACA,eAAA;AACJ;AACI;EACI,qBAAA;EACA,kBAAA;EACA,mBAAA;AACR;AAEI;EACI,kBAAA;EACA,UAAA;EACA,QAAA;AAAR;AACQ;EACI,4BAAA;AACZ","sourcesContent":[".fi-upgrade-message-notification {\r\n    display: block;\r\n    position: relative;\r\n    color: var(--fi-color-white);\r\n    background-color: var(--branded-background-color);\r\n    padding: 20px 5px;\r\n    font-size: 20px;\r\n\r\n    .fi-upgrade-message-header {\r\n        display: inline-block;\r\n        padding-left: 24px;\r\n        padding-right: 24px;\r\n    }\r\n\r\n    .fi-upgrade-message-notification-close {\r\n        position: absolute;\r\n        right: 0px;\r\n        top: 0px;\r\n        .fa {\r\n            color: var(--fi-color-white);\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
